import React from 'react';
import Reflux from 'reflux';
import Header from '../sections/Header';
import Topic from '../sections/Topic';
import Footer from '../sections/Footer';
import AppStore from '../AppStore';
import ModalStore from '../stores/ModalStore';
import ModalAlert from '../sections/ModalAlert';

class TopicPage extends Reflux.Component {
    constructor (props) {
        super(props);
        this.stores = [AppStore, ModalStore];
    }
    render () {
        return <div>
          <ModalAlert />
          <Header disableArrows={this.props.disableArrows} disableCreation={this.props.disableCreation} />
          <Topic topicId={this.props.topicId} title={this.props.title} autogenerateTitle={this.props.autogenerateTitle} disableArrows={this.props.disableArrows} disableCreation={this.props.disableCreation} />
          <Footer />
        </div>;
    }
}

export default TopicPage;



// WEBPACK FOOTER //
// ./src/pages/TopicPage.js